import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=2740811c&scoped=true"
import script from "./NotificationCenter.vue?vue&type=script&lang=js"
export * from "./NotificationCenter.vue?vue&type=script&lang=js"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=2740811c&prod&lang=less&scoped=true"
import style1 from "./NotificationCenter.vue?vue&type=style&index=1&id=2740811c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2740811c",
  null
  
)

export default component.exports